module.exports = __webpack_public_path__ + "9060a503dcc9a77647b65e77bca39632.pdf";